import { render, staticRenderFns } from "./AssociatedItemsTable.vue?vue&type=template&id=15ccae09&scoped=true&"
import script from "./AssociatedItemsTable.vue?vue&type=script&lang=ts&"
export * from "./AssociatedItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccae09",
  null
  
)

export default component.exports